import React, { useContext, useEffect, useState } from "react";
import "./MyProfile.css";
import BottomNav from "../../components/Bottom nav/BottomNav";
import { useHistory } from "react-router-dom";
import useProfileQuery from "../../store/Profile/useProfileQuery";
import { Avatar, Typography } from "@mui/material";
import useBusinessQuery from "../../store/Bussiness/useBusinessQuery";
import TermsAndCondition from "../../components/TermsAndCondition";
import { variableContext } from "../../context/VariableContex";

import AuthGate from "../../components/AuthGate/AuthGate";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";

const menuGroups = [
  {
    label: "Business Management",
    items: [
      {
        icon: <PersonOutlineIcon sx={{ fontSize: 20, color: "#2182B1" }} />,
        iconBg: "#e8f4f8",
        title: "Edit Profile",
        subtitle: "Update your basic business information",
        route: "/profile",
      },
      {
        icon: <CollectionsOutlinedIcon sx={{ fontSize: 20, color: "#8b5cf6" }} />,
        iconBg: "#f5f3ff",
        title: "Edit Images & Catalogues",
        subtitle: "Manage business images and catalogues",
        route: "/edit-images",
      },
      {
        icon: <InfoOutlinedIcon sx={{ fontSize: 20, color: "#10b981" }} />,
        iconBg: "#ecfdf5",
        title: "About & Services",
        subtitle: "Manage business description and services",
        route: "/edit-info",
      },
      {
        icon: <ShareOutlinedIcon sx={{ fontSize: 20, color: "#f59e0b" }} />,
        iconBg: "#fef9ec",
        title: "Social Media Information",
        subtitle: "Manage contact and social media links",
        route: "/edit-social",
      },
    ],
  },
  {
    label: "Account",
    items: [
      {
        icon: <StarBorderIcon sx={{ fontSize: 20, color: "#f59e0b" }} />,
        iconBg: "#fef9ec",
        title: "Subscription Details",
        subtitle: "View plan, status & remaining days",
        route: "/my-subscription",
      },
    ],
  },
  {
    label: "Support",
    items: [
      {
        icon: <HelpOutlineIcon sx={{ fontSize: 20, color: "#8b5cf6" }} />,
        iconBg: "#f5f3ff",
        title: "Help & Support",
        subtitle: "Get help from our team",
        route: "/help-support",
      },
      {
        icon: <PrivacyTipOutlinedIcon sx={{ fontSize: 20, color: "#0E3A53" }} />,
        iconBg: "#e8f4f8",
        title: "Privacy Policy",
        subtitle: "How we handle your data",
        route: null,
      },
      {
        icon: <GavelOutlinedIcon sx={{ fontSize: 20, color: "#6b7280" }} />,
        iconBg: "#f3f4f6",
        title: "Terms & Conditions",
        subtitle: "Our terms of service",
        route: "terms",
      },
    ],
  },
];

const MyProfile = () => {
  const history = useHistory();
  const { layoutMode } = useContext(variableContext);
  const [shopName, setShopName] = useState("");
  const [image, setImage] = useState("");
  const [mobile, setMobile] = useState("");
  const [userName, setUserName] = useState("");
  const [openTerms, setOpenTerms] = useState(false);
  const local = JSON.parse(localStorage.getItem("user"));

  const { data: profileData, isSuccess: profileSuccess } = useProfileQuery.Get_profile();
  const { data: bussinessList, isSuccess } = useBusinessQuery.Get_my_bussiness();

  const handleLogout = () => {
    if (local?.id) {
      localStorage.clear("accessToken");
      localStorage.clear("user");
      localStorage.clear("refreshToken");
    }
    history.push("/sign-in");
  };

  useEffect(() => {
    if (isSuccess && bussinessList && local?.id) {
      setShopName(bussinessList?.data?.results[0]?.name || "");
      setImage(bussinessList?.data?.results[0]?.image || "");
    }
  }, [isSuccess, bussinessList]);

  useEffect(() => {
    if (profileSuccess && profileData) {
      setMobile(profileData.data.mobile || "");
      setUserName(profileData.data.name || "");
    }
  }, [profileSuccess, profileData]);

  const handleMenuClick = (item) => {
    if (item.route === "terms") {
      setOpenTerms(true);
    } else if (item.route) {
      history.push(item.route);
    }
  };

  const bizStatus = isSuccess ? bussinessList?.data?.results?.[0]?.status : null;

  // ── Not logged in → show shared auth gate ──
  if (!local?.id) {
    return <AuthGate redirectTo="/my-profile" />;
  }

  return (
    <div className="mp-root">

      {/* ── Pending banner ── */}
      {bizStatus === "Pending" && (
        <div style={{
          margin: "12px 14px 0",
          background: "linear-gradient(135deg, #fff8e1, #fff3cd)",
          border: "1.5px solid #f59e0b",
          borderRadius: 12,
          padding: "12px 14px",
          display: "flex",
          flexDirection: "column",
          gap: 6,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 18 }}>⏳</span>
            <span style={{ fontWeight: 700, color: "#92400e", fontSize: 13 }}>Business Under Verification</span>
          </div>
          <p style={{ margin: 0, fontSize: 12, color: "#78350f", lineHeight: 1.6 }}>
            Your business will be approved within <strong>2 working days</strong>.
          </p>
          <a
            href="https://wa.me/917293838383"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              background: "#25D366", color: "#fff",
              padding: "6px 14px", borderRadius: 50,
              textDecoration: "none", fontWeight: 600, fontSize: 12,
              alignSelf: "flex-start",
            }}
          >
            💬 Contact on WhatsApp
          </a>
        </div>
      )}

      {/* ── Compact Header ── */}
      <div className="mp-header">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: "0 4px" }}>
          <Typography className="mp-header-title">My Profile</Typography>
        </div>
        <div className="mp-header-profile">
          <Avatar
            src={image || "/images/user-img.png"}
            className="mp-header-avatar"
            sx={{ width: 72, height: 72 }}
          />
          <Typography className="mp-user-name">
            {userName || local?.name || "Your Name"}
          </Typography>
          <Typography className="mp-user-mobile">
            {mobile || local?.mobile || ""}
          </Typography>
          {shopName ? (
            <Typography className="mp-user-shop">🏪 {shopName}</Typography>
          ) : null}
        </div>
      </div>

      {/* ── Subscription banner ── */}
      <div className="mp-subs-banner" onClick={() => history.push("/my-subscription")}>
        <div className="mp-subs-banner-text">
          <Typography className="mp-subs-banner-title">Subscription Details</Typography>
          <Typography className="mp-subs-banner-sub">View plans, pricing &amp; features</Typography>
        </div>
        <div className="mp-subs-banner-btn">View Plans</div>
      </div>

      {/* ── Menu Groups ── */}
      <div className="mp-menu-section">
        {menuGroups.map((group) => (
          <div key={group.label} style={{ marginBottom: 4 }}>
            <Typography className="mp-section-label" sx={{ mt: 2, mb: 1 }}>
              {group.label}
            </Typography>
            <div className="mp-menu-card">
              {group.items.map((item, idx) => (
                <div
                  key={idx}
                  className="mp-menu-item"
                  onClick={() => handleMenuClick(item)}
                  style={{ borderBottom: idx < group.items.length - 1 ? "1px solid #f0f4f7" : "none" }}
                >
                  <div className="mp-menu-icon-wrap" style={{ background: item.iconBg }}>
                    {item.icon}
                  </div>
                  <div className="mp-menu-text">
                    <Typography className="mp-menu-title">{item.title}</Typography>
                    <Typography className="mp-menu-subtitle">{item.subtitle}</Typography>
                  </div>
                  <ChevronRightIcon className="mp-menu-arrow" />
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Logout */}
        <div className="mp-logout-item" onClick={handleLogout}>
          <div className="mp-logout-icon-wrap">
            <LogoutIcon sx={{ fontSize: 20, color: "#e53935" }} />
          </div>
          <Typography className="mp-logout-title">Logout</Typography>
          <ChevronRightIcon sx={{ color: "#f5c6c6", fontSize: 18 }} />
        </div>

        <Typography className="mp-version">MasterClick v1.0</Typography>

        {/* Home button */}
        <button className="mp-home-btn" onClick={() => history.push("/")}>
          <HomeIcon style={{ fontSize: 20 }} />
          <span>Home</span>
        </button>
      </div>

      <BottomNav />
      {openTerms && (
        <TermsAndCondition open={openTerms} handleClose={() => setOpenTerms(false)} />
      )}
    </div>
  );
};

export default MyProfile;
